import mitt, { Emitter } from 'mitt'

type ExtendedEmitter = Emitter<any> & {
    onMultiple: (events: string[], handler: (event: any) => void) => void
}

const emitter = mitt() as ExtendedEmitter

emitter.onMultiple = function (events, handler) {
    for (const event of events) {
        this.on(event, handler)
    }
};

export default emitter
